import React from 'react';

const Subcategory = (props) => {
    return (
        <div
            className="item-subcategory"
            onClick={props.handleClick} >
            <span>{props.title}</span>
            <i className="icon-arrow-down-sign-to-navigate"></i>
        </div>
    );
}

export default Subcategory;